'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.tickets = twentyninetimes.tickets || function () {

    let triggerList = [];

    function init() {
        overlayPop();
    }

    function overlayPop() {
     

        triggerList = document.querySelectorAll(".ticket-inactivebtn,.ticket-overlaytrigger");
        if(triggerList.length === 0){
            // Dang.. no triggers
            // console.log('no triggers')
        }else{
            triggerList.forEach(item => {
                item.addEventListener('click', event => {
                
                    let popContent = item.closest('.ticket').querySelector('.ticket-extra');
                    let ticket = item.closest('.ticket');

                    ticket.classList.add('popopen');
                    setTimeout(function() {
                        popContent.classList.add('active');
                    }, 350);

                    popContent.querySelectorAll('.closeit').forEach(item => {
                        item.addEventListener('click', event => {
                            popContent.classList.remove('active');
                            ticket.classList.remove('popopen');

                        })
                    })
                })
            });
        }

    }

    return {
        init : init
    };

}();